module.exports = __webpack_public_path__ + "static/media/nodevice Copy.f0a9f44b.png";